<template>
  <div class="content">
    <IconBlock :card-data="cardData" @selected-index="selectedIcon" />

    <MessageBlock
      ref="resetChildMessage"
      :picture="picture"
      :message-list="messageList"
    />

    <Button
      class="share"
      :text="'通知好友'"
      :disable="disable"
      full
      @click="shareMessage"
    />

    <Overlay v-if="shareBlockDisplay" blur @click="closeShareBlock" />

    <div class="share-block" :class="{ active: shareBlockDisplay }">
      <div class="title">
        通知好友
        <img :src="iconCross" @click="closeShareBlock" />
      </div>
      <div class="icon-box">
        <div>
          <img :src="iconLine" @click="doLine" />
          <div>LINE</div>
        </div>
        <div>
          <img :src="iconWhatsApp" @click="doWhatsapp" />
          <div>WhatsApp</div>
        </div>
        <div>
          <img :src="iconSMS" @click="doSMS" />
          <div>簡訊</div>
        </div>
        <div>
          <img :src="iconMail" @click="doMail" />
          <div>Email</div>
        </div>
        <div>
          <img :src="iconCopy" @click="doCopy" />
          <div>複製連結</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createApp, computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import api from '../api';
import emitter from '../helpers/emitter';
import { openLoading, closeLoading } from '../helpers/loading';
import { encrypt } from '../helpers/crypt';
import IconBlock from '../components/IconBlock.vue';
import MessageBlock from '../components/MessageBlock.vue';
import Overlay from '../components/Overlay.vue';
import Button from '../components/Button.vue';
import VueClipboard, { copyText } from 'vue3-clipboard';
import iconLine from '../assets/icon/i-share-line.svg';
import iconWhatsApp from '../assets/icon/i-share-whatsapp.svg';
import iconSMS from '../assets/icon/i-share-sms.svg';
import iconMail from '../assets/icon/i-share-mail.svg';
import iconCopy from '../assets/icon/i-share-copy.svg';
import iconCross from '../assets/icon/i-cross-black.svg';

const app = createApp();

app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
});

export default {
  name: 'Home',
  components: {
    IconBlock,
    MessageBlock,
    Overlay,
    Button,
  },
  setup() {
    console.log('ver: 2.0');
    const route = useRoute();
    const store = useStore();

    const cardData = ref([]);
    const selectedIconIndex = ref(0);
    const messageList = ref([]);
    const getCardsInfo = () => {
      api
        .getCardList()
        .then((res) => {
          cardData.value = res.cardList;
          messageList.value =
            cardData.value[selectedIconIndex.value].messageList;
          picture.value = res.cardList[0].image;
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const token = route.query.t;
    onMounted(() => {
      api.updateToken(token);
      getCardsInfo();
    });

    const picture = ref('');
    const resetChildMessage = ref(null);
    const selectedIcon = (index) => {
      if (selectedIconIndex.value === index) return;

      selectedIconIndex.value = index;
      messageList.value = cardData.value[selectedIconIndex.value].messageList;
      picture.value = cardData.value[index].image;
      resetChildMessage.value.resetMessage();
    };

    const disable = computed(() => {
      return store.getters.getButtonStatus;
    });

    const shareBlockDisplay = ref(false);
    const openShareBlock = () => {
      shareBlockDisplay.value = true;
    };

    const closeShareBlock = () => {
      shareBlockDisplay.value = false;
    };

    const doLine = () => {
      const giftUrl = `${domain.value}${cardId.value}?s=${isSns.value}`;
      const string = `${shareText1.value}%0D%0A ${giftUrl} %0D%0A%0D%0A${shareText2.value}%0D%0A ${helpLink.value}`;
      window.location.replace(`https://line.naver.jp/R/msg/text/?${string}`);
    };

    const doWhatsapp = () => {
      const giftUrl = `${domain.value}${cardId.value}?s=${isSns.value}`;
      const string = `${shareText1.value}%0D%0A ${giftUrl} %0D%0A%0D%0A${shareText2.value}%0D%0A ${helpLink.value}`;
      window.location.replace(`https://api.whatsapp.com/send?text=${string}`);
      // window.location = `whatsapp://send?text=${string}`; // 直接開 app
    };

    const isAn = Boolean(navigator.userAgent.toLowerCase().match('android'));
    const doSMS = () => {
      const giftUrl = `${domain.value}${cardId.value}?s=${isSns.value}`;
      const string = `${shareText1.value}%0D%0A ${giftUrl} %0D%0A%0D%0A${shareText2.value}%0D%0A ${helpLink.value}`;
      const smsScheme = isAn ? 'sms:?body=' : 'sms:&body=';
      window.location.replace(`${smsScheme}${string}`);
    };

    const doMail = () => {
      const giftUrl = isAn
        ? `${domain.value}${cardId.value}?s%3d${isSns.value}`
        : `${domain.value}${cardId.value}%3fs%3d${isSns.value}`;
      const string = isAn
        ? `${shareText1.value} ${giftUrl} ${shareText2.value} ${helpLink.value}`
        : `${shareText1.value}%0D%0A ${giftUrl} %0D%0A%0D%0A${shareText2.value}%0D%0A ${helpLink.value}`;

      window.location.replace(
        `mailto:?subject=${shareText1.value}&body=${string}`,
      );
    };

    const doCopy = () => {
      const giftUrl = `${domain.value}${cardId.value}?s=${isSns.value}`;
      const string = `${shareText1.value}\r\n ${giftUrl} \r\n\r\n${shareText2.value}\r\n ${helpLink.value}`;
      copyText(string, undefined, (error, event) => {
        if (error) {
          emitter.emit('callMessager', {
            message: '此手機不支援複製功能',
            action: () => {},
          });
          console.log(error);
        } else {
          emitter.emit('callMessager', {
            message: '分享的訊息已複製',
            action: () => {},
          });
          console.log(event);
        }
      });
    };

    const domain = ref(process.env.VUE_APP_SHARE_URL);
    const cardId = ref('');
    const isSns = ref(route.query.s && route.query.s === 't' ? 't' : 'f');
    const shareText1 = ref(
      '您的朋友透由全家APP隨買跨店取轉贈商品禮物給您，快打開來看看 !',
    );
    const shareText2 = ref('隨買跨店取使用說明：');
    const helpLink = ref('https://nevent.family.com.tw/Preorder/');
    const shareMessage = () => {
      openLoading();

      const textareaMessage = store.getters.getMessage;
      const message = textareaMessage.substr(0, 30);
      const image = cardData.value[selectedIconIndex.value].image;
      const time = Math.floor(new Date() / 1000);

      let infos = route.query.infos
        ? encodeURIComponent(route.query.infos)
        : '';
      if (infos.indexOf('%20') !== -1) {
        infos = infos.split('%20').join('%2B');
      }

      api
        .setCardInfo(image, message, time, infos)
        .then((res) => {
          if (res && res.CardId) {
            cardId.value = encrypt(res.CardId);

            openShareBlock();
            closeLoading();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
    return {
      cardData,
      messageList,
      selectedIconIndex,
      resetChildMessage,
      picture,
      disable,
      selectedIcon,
      shareBlockDisplay,
      closeShareBlock,
      shareMessage,
      doLine,
      doWhatsapp,
      doSMS,
      doMail,
      doCopy,
      iconLine,
      iconWhatsApp,
      iconSMS,
      iconMail,
      iconCopy,
      iconCross,
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100vw;
  min-height: calc(100vh - 44px);
  margin-top: 44px;
  padding: 16px;
  position: relative;
}

.url-display {
  width: 100%;
  padding: 10%;
  word-break: break-all;
}

.share-block {
  width: 100vw;
  height: 174px;
  padding: 24px 0px 32px;
  background-color: #ffffff;
  border-radius: 8px 8px 0px 0px;
  position: fixed;
  left: 0;
  bottom: -200px;
  z-index: 10;
  transition: bottom 0.5s;

  .title {
    height: 25px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    line-height: 26px;

    img {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 4px;
      right: 28px;
    }
  }

  .icon-box {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    div + div {
      margin-left: 20px;
    }

    div div {
      margin-top: 8px;
      font-size: 12px;
      line-height: 17px;
    }
  }

  &.active {
    bottom: 0px;
  }
}
</style>
